import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** 1 or 2 column responsive grid; defaults to 1 on mobile / 2 on sm+. */
  columns?: 1 | 2 | 3;
  className?: string;
}

const COLS: Record<1 | 2 | 3, string> = {
  1: "grid grid-cols-1 gap-3",
  2: "grid grid-cols-1 gap-3 sm:grid-cols-2",
  3: "grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3",
};

const ChoiceComparisonGrid = ({ children, columns = 2, className = "" }: Props) => (
  <div className={`${COLS[columns]} ${className}`}>{children}</div>
);

export default ChoiceComparisonGrid;